import { render, staticRenderFns } from "./DevModePanel.vue?vue&type=template&id=88ffbfb2&scoped=true"
import script from "./DevModePanel.vue?vue&type=script&lang=js"
export * from "./DevModePanel.vue?vue&type=script&lang=js"
import style0 from "./DevModePanel.vue?vue&type=style&index=0&id=88ffbfb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ffbfb2",
  null
  
)

export default component.exports